import Page from '../Page';
import Index from './index.vue';
/* eslint-disable no-new */

new Page({
  routes: [
    {
      path: '/',
      component: Index,
      meta: { title: '大学搜题酱' }
    }
  ]
});
